<template>
    <div class="threshold-rule-row q-px-none q-pt-none q-pb-sm">
        <span class="threshold-rule-prefix text--primary">{{ Translate('If') }}</span>
        <div class="threshold-rule-field">
            <q-select
                v-model="selected_item"
                :options="options"
                option-label="text"
                option-value="value"
                emit-value
                map-options
                :label="Translate('Select')"
                outlined
                dense
                class="full-width"
                bg-color="white"
                hide-bottom-space
                :error="hasValueError"
            />
        </div>
        <span class="threshold-rule-then text--primary">{{ Translate('then') }}</span>
        <div class="threshold-rule-format-field">
            <ThresholdformatOptions ref="formatOptions" :EventBus="EventBus" :defaultColor="value.color" @thresholdFormatChanged="thresholdFormatChanged"/>
        </div>
    </div>
</template>
    

<script>
    import { QSelect } from 'quasar';
    import methods from '@/Shared/methods';
    import ThresholdformatOptions from './threshold_formatOptions.vue';
    import common from './common.js';

    export default {
        components: {
            ThresholdformatOptions,
            QSelect,
        },
        // Declare so parent listeners are component emits (Vue 3); same pattern as filter_*.vue (CCDEV-18136).
        emits: ['thresholdValuesChanged', 'thresholdFormatChanged'],
        data: function () {
            return {
                selected_item: null,
                hasValueError: false,
            }
        },
        props: {
            item: Object,
            value: null,
        },
        created() {
            const initialValue = this.value?.values ?? this.value?.value;
            if (initialValue != null)
                this.selected_item = Array.isArray(initialValue) ? initialValue[0] : initialValue;
        },
        watch: {
            selected_item: function (newv) {
                if (newv == null || newv === '')
                    this.$emit('thresholdValuesChanged', {});
                else
                    this.$emit('thresholdValuesChanged', {
                        filterType: "set",
                        values: [newv],
                        value: [newv],
                        type: "boolean"
                    });
            },
        },
        computed:{
            options: function () {
                return [
                    { text: this.Translate('True'), value: 'True' },
                    { text: this.Translate('False'), value: 'False' }
                ];
            },
            valueRules() {
                return [
                    v => this.options.some(o => o.value === v) || this.Translate('Please select a value')
                ];
            },
        },     
        methods: {
            ...methods,
            thresholdFormatChanged(message){
                this.$emit('thresholdFormatChanged', message);
            },
            triggerValidation() {
                this.hasValueError = common.hasValidationError(this.valueRules, this.selected_item);
            },
            validate() {
                this.triggerValidation();
                const formatValid = this.$refs.formatOptions?.validate?.() ?? true;
                return !this.hasValueError && formatValid;
            },
        }
    }
</script>

<style src="./threshold_row.css"></style>

<style scoped>
    .verydense {
        max-height: 24px;
        min-height: 24px;
    }

    .mediumdense {
        max-height: 28px;
        min-height: 28px;
    }
</style>
